import React from 'react';
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import ContactForm from '../forms/ContactForm';

interface ContactFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'contact' | 'demo' | 'consultation' | 'cv-registration';
  title?: string;
  subtitle?: string;
}

export const ContactFormModal = ({
  isOpen,
  onClose,
  type,
  title,
  subtitle
}: ContactFormModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] max-w-[600px] max-h-[85vh] overflow-y-auto p-4 md:p-6">
        <DialogTitle className="sr-only">
          {title || 'Formulario de contacto'}
        </DialogTitle>
        <ContactForm 
          type={type}
          title={title}
          subtitle={subtitle}
          onSuccess={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};